module.exports = __webpack_public_path__ + "static/media/logo.475b58f8.png";